<template>
    <FicheRecensement />
</template>

<script lang="ts">
import { defineComponent } from "vue";
//import BreadCrumb from "../../components/Common/BreadCrumb.vue";

import FicheRecensement from "../../components/FicheRecensement/FicheRecensement.vue";

export default defineComponent({
    name: "FicheRecensementPage",
    components: {
       // BreadCrumb,
        FicheRecensement,
    },
});
</script>